'use strict';
'use client';
import { j as n } from "../../external/react/jsx-runtime.js";
import { faPlus as l } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import { FontAwesomeIcon as g } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import c from "../../external/classnames/index.js";
import f from "html-react-parser";
import { useRef as h, useEffect as u } from "react";
import a from "./accordion.module.scss.js";
const R = ({
  title: p,
  isActive: e = !1,
  activeColor: s,
  textColor: o,
  bgColor: m,
  onClick: d,
  content: i
}) => {
  const t = h(null);
  return u(() => {
    const r = t.current;
    r && s && r.parentNode.style.setProperty(
      "--active-color",
      s
    );
  }, [s]), u(() => {
    e && setTimeout(() => {
      if (t != null && t.current && // Check if the accordion is not in view or larger than the viewport
      (t.current.clientHeight > window.innerHeight || t.current.getBoundingClientRect().top < 0)) {
        const r = t.current.getBoundingClientRect().top + window.pageYOffset - 16;
        window.scrollTo({
          top: r,
          behavior: "smooth"
        });
      }
    }, 100);
  }, [e]), /* @__PURE__ */ n.jsxs(
    "div",
    {
      ref: t,
      className: c(a.accordion__item, {
        [`bg-${m}`]: m
      }),
      "data-expanded": e,
      "data-testid": "accordion-item",
      children: [
        /* @__PURE__ */ n.jsxs(
          "button",
          {
            className: c(a.accordion__button, {
              [`text-${o}`]: o
            }),
            onClick: () => {
              d && d();
            },
            children: [
              f(p),
              /* @__PURE__ */ n.jsx(g, { icon: l, "data-active": e })
            ]
          }
        ),
        /* @__PURE__ */ n.jsx(
          "div",
          {
            className: c(a.accordion__content, {
              [`text-${o}`]: o
            }),
            role: "region",
            children: typeof i == "string" ? f(i) : i
          }
        )
      ]
    }
  );
};
export {
  R as default
};
